var render, staticRenderFns
import script from "./BrandCampaignShowPage.vue?vue&type=script&lang=js"
export * from "./BrandCampaignShowPage.vue?vue&type=script&lang=js"
import style0 from "./BrandCampaignShowPage.vue?vue&type=style&index=0&id=984362de&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports